import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/thumbs/thumbs.min.css";
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";
// import { getDetailsAction } from "store/jobDetails";
// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from "swiper/core";
import videoSlider1 from "views/job-details/img/videoslider/video1.png";
import videoSlider2 from "views/job-details/img/videoslider/play-button.svg";
import settingicon from "views/job-details/img/factorcards/setting.png";

import communication from "views/job-details/img/factorcards/communication.png";
import network from "views/job-details/img/factorcards/network.png";
import XMLID_2529_ from "views/job-details/img/factorcards/XMLID_2529_.png";
import document from "views/job-details/img/factorcards/document.png";
import art from "views/job-details/img/factorcards/art.png";
// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default function App() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <div>
        <div>
          <div className="flex justify-between items-center mt-24 mb-8">
            <h2 className="fsize28 font-bold">VIDEO ON BUSINESS LOANS</h2>
            <button
              class="hover-changetext"
              type="button"
              data-hover="VIEW ALL"
            >
              <span>CHECK OUT ITV</span>
            </button>
          </div>
          <div>
            <Swiper
              style={{
                "--swiper-navigation-color": "#fff",
                "--swiper-pagination-color": "#fff",
              }}
              spaceBetween={10}
              navigation={false}
              thumbs={{ swiper: thumbsSwiper }}
              className="mySwiper2 rounded-12px"
            >
              <SwiperSlide className="video-sli-rem rounded-12px">
                <div className="relative">
                  <h2 class="fsize28 font-bold inside-video-t text-white">
                    In-branch Video Banking
                  </h2>
                  <img
                    src={videoSlider1}
                    alt="video"
                    className="w-full rounded-12px h-88vh "
                  />
                  <div className="h-full flex justify-center items-center ">
                    <div className="absolute flex top-45per	 justify-center items-center ">
                      <img
                        src={videoSlider2}
                        alt="video"
                        className="w-auto h-auto  "
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className="video-sli-rem">
                <div className="relative">
                  <h2 class="fsize28 font-bold inside-video-t text-white">
                    In-branch Video Banking
                  </h2>
                  <img
                    src={videoSlider1}
                    alt="video"
                    className="w-full rounded-12px h-88vh "
                  />
                  <div className="h-full flex justify-center items-center ">
                    <div className="absolute flex top-45per	 justify-center items-center ">
                      <img
                        src={videoSlider2}
                        alt="video"
                        className="w-auto h-auto  "
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

        <div className="mt-20">
          <h1 className="font-bold text-black fsize28 uppercase">
            A Paragraph can go here
          </h1>
          <p className="text424B5A fsize18 mt-8">
            Participants will be shortlisted on merit and will be invited for
            the selection process. Shortlisted participants will have to go
            through the below mentioned selection stages:
          </p>

          <div className="mt-8 pr-4">
            <p className="fsize18 font-bold text424B5A mb-2">
              Entrance test -
              <span className="font-normal ml-1">
                The entrance test aims at measuring the aptitude of the
                participants through verbal ability, numerical ability and
                logical reasoning.
              </span>
            </p>

            <p className="fsize18 font-bold text424B5A mb-2">
              Group discussion stage -
              <span className="font-normal ml-1">
                Participants clearing the aptitude test will be invited for case
                based group discussion. The group discussions are mainly
                conducted to judge participants on their analytical thinking,
                approach adapted to business situations and the ability to break
                down complex problems to arrive at solutions.
              </span>
            </p>

            <p className="fsize18 font-bold text424B5A mb-2">
              Psychrometric Profiling / Personal Interview -
              <span className="font-normal ml-1">
                Applicant clearing GD stage will be eligible for the Personal
                Interview Stage.
              </span>
            </p>
          </div>
        </div>

        {/* factoers card */}
        <div className="mt-28">
          {" "}
          <div className="flex justify-between items-center  mb-8">
            <h2 className="fsize28 font-bold uppercase">Few success factors</h2>
          </div>
          <div className="grid grid-cols-6 gap-6">
            <card className="drop-shadow rounded-12px bgE77820 text-center  p-20px">
              <img src={settingicon} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-white">
                Service Orientation
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={communication} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Passion to meet customers
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={network} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Work with cross functional teams
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={XMLID_2529_} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Analytical mindset
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={document} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Analyse financial statements
              </p>
            </card>

            <card className="drop-shadow rounded-12px text-center  p-20px">
              <img src={art} alt="setting-img" className="m-auto" />
              <p className="font-medium pt-4 fsize18 text-black">
                Quick learner
              </p>
            </card>
          </div>
        </div>
      </div>
    </>
  );
}
